export enum userType {
    Primary,
    Secondary,
    None,
    AlachisoftWebsite,
    CloudWithoutPassword
}